import { useTranslation } from "react-i18next";
import { mainSiteUrl } from "@/mocks/categories";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20bright%20airy%20editorial%20scene%20of%20a%20modern%20minimalist%20desk%20with%20an%20open%20laptop%20displaying%20a%20clean%20spreadsheet%20grid%2C%20surrounded%20by%20neatly%20arranged%20white%20sneakers%2C%20a%20folded%20sage%20green%20hoodie%20and%20a%20beige%20cap%2C%20soft%20warm%20natural%20window%20light%2C%20premium%20workspace%20styling%2C%20warm%20neutral%20cream%20and%20soft%20pastel%20tones%2C%20gentle%20soft%20shadows%2C%20high%20detail%2C%20harmonious%20composition&width=1600&height=900&seq=hero-bg-2026&orientation=landscape&nocache=true"
          alt="AllChinaBuy spreadsheet finds — organized fashion products on a modern desk"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 pt-32 pb-24 md:pt-40 md:pb-32">
        <div className="max-w-7xl mx-auto flex flex-col items-center text-center">
          <span className="animate-fade-up inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/90 backdrop-blur text-foreground-900 text-xs font-semibold tracking-widest uppercase">
            <i className="ri-sparkling-2-line text-primary-600"></i>
            {t("hero.eyebrow")}
          </span>

          <h1 className="animate-fade-up font-heading font-bold text-3xl md:text-5xl lg:text-6xl text-background-50 leading-tight mt-6 max-w-4xl">
            {t("hero.title")}
          </h1>

          <p className="animate-fade-up text-base md:text-lg text-background-100/90 leading-relaxed mt-5 max-w-2xl">
            {t("hero.subtitle")}
          </p>

          <div className="animate-fade-up flex flex-col sm:flex-row items-center gap-3 mt-8">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-7 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              {t("hero.ctaPrimary")}
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-7 py-3.5 rounded-md bg-accent-500 text-background-50 text-sm md:text-base font-semibold hover:bg-accent-600 transition-colors whitespace-nowrap"
            >
              {t("hero.ctaSecondary")}
            </a>
          </div>

          <p className="animate-fade-up flex items-center gap-2 text-xs text-background-100/80 mt-6">
            <i className="ri-shield-check-line text-sm text-primary-300"></i>
            {t("hero.trust")}
          </p>
        </div>
      </div>
    </section>
  );
}